import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getRegionForServiceShop = createAsyncThunk('/getRegionForServiceShop', async () => {
  const response = await axios.get('/GetRegionForServiceShop');
  return response.data;
});

export const getServiceShopForRegion = createAsyncThunk('/GetServiceShopForRegion', async (parentSourceServiceShopId) => {
    const response = await axios.get(`/GetServiceShopForRegion/${parentSourceServiceShopId}`);
    return response.data;
});

export const getSmsReportsData = createAsyncThunk('/GetSmsReportsData',
async (ids) => {
  const response = await axios.get(`/GetSmsReportsData/${ids[0]}/${ids[1]}/${ids[2]}`);
  return response.data;
});

export const getSmsNpsReportsData = createAsyncThunk('/GetSmsNpsReportsData',
async (ids) => {
  const response = await axios.get(`/GetSmsNpsReportsData/${ids[0]}/${ids[1]}/${ids[2]}`);
  return response.data;
});

const smsReportSlice = createSlice({
    name: 'smsReport',
    initialState: {
      loading: false,
      error: '',
      RegionServiceControl: [],
      SubServiceShopControl: [],
      SmsData:[],
      NpsData:[],
      SelectedAppTranslationId: 0,
    },
    reducers: {
      changeSelectedAppTranslationId(state, action) {
        state.SelectedAppTranslationId = action.payload;
      },
      resetDescriptions(state) {
        state.RegionServiceControl = [];
      },
    },
    extraReducers: {
      [getRegionForServiceShop.pending]: (state) => {
        state.loading = true;
      },
      [getRegionForServiceShop.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getRegionForServiceShop.fulfilled]: (state, action) => {
        state.RegionServiceControl = action.payload;
        state.loading = false;
      },
      [getServiceShopForRegion.pending]: (state) => {
        state.loading = true;
      },
      [getServiceShopForRegion.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getServiceShopForRegion.fulfilled]: (state, action) => {
        state.SubServiceShopControl = action.payload;
        state.loading = false;
      },
      [getSmsReportsData.pending]: (state) => {
        state.loading = true;
      },
      [getSmsReportsData.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getSmsReportsData.fulfilled]: (state, action) => {
        state.SmsData = action.payload;
        state.loading = false;
      },
      [getSmsNpsReportsData.pending]: (state) => {
        state.loading = true;
      },
      [getSmsNpsReportsData.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getSmsNpsReportsData.fulfilled]: (state, action) => {
        state.NpsData = action.payload;
        state.loading = false;
      },
    }
  });
  export const smsReportActions = smsReportSlice.actions;
  export default smsReportSlice;